module.exports = __webpack_public_path__ + "img/bg1.76c5b0b3.png";